module.exports = __webpack_public_path__ + "img/physics-seal.35cea8fd.png";